import { loadModules } from "esri-loader";
import { toast } from "react-toastify";
import { convertGeometryToWebMercator } from "../../../lib/Customer/convertSpatialSystem";
import { getRandomColorArray } from "../../../lib/Customer/generateColor";
import { addsketchView } from "../../../lib/Customer/Sketch";
import { switchView } from "../../../lib/Customer/SwitchMap";
import { ProjectTy } from "../../../ReduxTool/Slice/Auth/types";
import { setMapActive } from "../../../ReduxTool/Slice/Map/MapReducer";
import { AppDispatch } from "../../../ReduxTool/store/store";
import { LocationMarker } from "../../Const";
import { extrudeSymbol3D, getsimpleFillSymbol } from "../../CustomerMaps/MarkerSymbols/MarkerSymbols";
import { lazyLoadArcGisMapModules, loadMultipleModules } from "./LazyloadMap";
import { pvHandleRoofTop } from "../GenerateRoof/GenrateRoof";
import { FinRes } from "../../../ReduxTool/Slice/Consumer/types";
import Point from "@arcgis/core/geometry/Point";
import Graphic from "@arcgis/core/Graphic";
import MapView from "@arcgis/core/views/MapView";
import { sketchVMhandle } from "../../../lib/handles/sketchVMhandle";
import * as reactiveUtils from "@arcgis/core/core/reactiveUtils";
import ScaleBar from "@arcgis/core/widgets/ScaleBar";
import Polygon from "@arcgis/core/geometry/Polygon";
import Polyline from "@arcgis/core/geometry/Polyline";
import SpatialReference from "@arcgis/core/geometry/SpatialReference";
import * as projection from "@arcgis/core/geometry/projection";
import GraphicsLayer from "@arcgis/core/layers/GraphicsLayer";
import Color from "@arcgis/core/Color";
import WebTileLayer from "@arcgis/core/layers/WebTileLayer.js";
import Basemap from "@arcgis/core/Basemap.js";
import { LayerProperties } from "../../Fetch3D/geoservertypes";
import SceneView from "@arcgis/core/views/SceneView";
import Map from "@arcgis/core/Map.js";
import Compass from "@arcgis/core/widgets/Compass";
import ShadowCast from "@arcgis/core/widgets/ShadowCast";
import { SimpleFillSymbol } from "@arcgis/core/symbols";
import Sketch from "@arcgis/core/widgets/Sketch";
import { hideAppleBasemap, showAppleBasemap } from "./appleBasemap";
import { anchorScene3dLayers, buildProjectScene3dLayers } from "./projectRoofOverlays";

export const building_index = 'index'
type IndexedGraphic = Record<number, __esri.Graphic>
export type MapViewType = '2D' | '3D'
export const SCENE_3D_CONTAINER_ID = "consumerScene3d"

const googleMapsApiKey = process.env.REACT_APP_GOOGLE_MAPS_TILE_API_KEY ?? "";
let googleTileSession: string | null = null;
let googleTileSessionExpiry = 0;

// The map itself comes from the CDN ArcGIS build (esri-loader); basemaps and
// views put on it must come from that same build, not from @arcgis/core.
const loadBasemapClasses = async () => {
    const [CdnBasemap, CdnWebTileLayer] = await loadMultipleModules(["esri/Basemap", "esri/layers/WebTileLayer"]);
    return { CdnBasemap, CdnWebTileLayer };
};

const createGoogleBasemap = async () => {
    const { CdnBasemap, CdnWebTileLayer } = await loadBasemapClasses();
    if (!googleMapsApiKey) throw new Error("Google Maps imagery is not configured.");
    if (!googleTileSession || Date.now() >= googleTileSessionExpiry) {
        const response = await fetch(`https://tile.googleapis.com/v1/createSession?key=${googleMapsApiKey}`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ mapType: "satellite", language: "en-US", region: "US", highDpi: true }),
        });
        if (!response.ok) throw new Error(`Google Maps imagery session failed (${response.status}).`);
        const session = await response.json();
        googleTileSession = session.session;
        googleTileSessionExpiry = Number(session.expiry) * 1000;
    }
    const layer = new CdnWebTileLayer({
        urlTemplate: `https://tile.googleapis.com/v1/2dtiles/{level}/{col}/{row}?session=${googleTileSession}&key=${googleMapsApiKey}`,
        title: "Google Satellite Imagery",
    });
    return new CdnBasemap({ baseLayers: [layer], title: "Google Maps", id: "google-basemap" });
};

const globalLayers = {
    scenemap : null as  Map | null, 
    initialiseProps: async function (mapRef: React.MutableRefObject<HTMLDivElement | null>, lng: number, lat: number,dispatch:AppDispatch) {
        const { GraphicsLayer, Map, MapView } = await lazyLoadArcGisMapModules();

        this.sketchLayers = new GraphicsLayer({
            title: "sketch-layer",
            id: "sketch-layer"
        });
        this.prevsketchLayers = new GraphicsLayer({
            title: "sketch-layer",
            id: "sketch-layer"
        });
        this.graphic3dLayers = new GraphicsLayer({
            title: "3d",
            id: '3d'
        });
        this.graphicLayerLocation = new GraphicsLayer({
            id: LocationMarker,
            title: LocationMarker
        });
        this.roofModuleGraphicLayer = new GraphicsLayer({
            title: 'Roof Modules'
        });
        this.map = new Map({
            basemap: "hybrid",
            ground: "world-elevation",
            layers: [globalLayers.graphicLayerLocation],
            
        });
        // this.map!.basemap = this.googleBasemap;
        this.view = new MapView({
            container: mapRef.current!,
            map: this.map,
            center: [lng, lat],
            zoom: 3,
        });
        this.mapView2d = this.view;
        this.container = mapRef.current;
        this.activeBasemap = "hybrid";

        dispatch(setMapActive("esri"))
        // if(this.indiLayers){
        //     this.indiLayers.visible = false
        //   }

    },
    sceneView: null as SceneView | null,
    mapView2d: null as MapView | null,
    activeBasemap: "hybrid" as string,
    compassWidget: null as any,
    sceneHeadingWatch: null as null | { remove: () => void },
    isSceneView: false,
    lastAddedGraphicName: null as any,
    markerLocation: { x: 0, y: 0 },
    // Map point of the last right-click; the "Place Marker" prompt is pinned to it
    rightClickMapPoint: null as __esri.Point | null,
    load: 0,
    isDone: false,
    sanctionload: 0,
    totalroofArea: 0,
    trackMarker:false,
    plantcapacity: 0,
    sanctionload2: 0,
    roofConfirmed: false,
    selected_index: null  as  number  | null,

    googleBasemap: {} as Basemap,

    userCurrentLocation: {
        lat: 0,
        lng: 0
    },
    isSavedProject: false  as boolean,

    
    degradation: null  as any,
    selected_project: null  as any | ProjectTy,
    financial: null  as FinRes | null,
    projectid: null  as string | null,

    //
    totalNumberofModules: 0,

    markerState: '' as 'move' | 'move-stop' | 'idle' | 'active' | 'complete',
    // dom x and y coordinates
    lastCursorPositionSelected: { x: 0, y: 0 },
    showRoofSelectionBtn: false,
    customButton: null as null | HTMLButtonElement,

    weatherStations: [] as __esri.Graphic[],

    currentSelectedProject: [] as ProjectTy[],

    lastDrawnRoofBoundry: null as __esri.Graphic | null,
    lastDrawnRoofBoundryGraphicTitle: null as string | null,

    weatherSelectionCircleGraphic: null as __esri.Graphic | null,

    currentZoomLevel: 3 as number,
    shiftPressed: false,

    // to hold tempGraphic while pointer is moving 
    tempGraphic: null as __esri.Graphic | null,
    guidinglines: {
        verticalLine: null as __esri.Graphic | null,
        horizontalLine: null as __esri.Graphic | null,
    },
    // to hold all the added graphic 
    addedBlocks: [] as __esri.Graphic[],

    // to store records of line and points wrt titlenames
    graphicLinesObjects: {} as Record<string, IndexedGraphic>,

    // selection tools 
    selectionTool: '' as '' | 'rectangle-selection' | 'rectangle',

    // map layer and view 
    map: null as null | __esri.Map, // Store the map object
    view: null as null | MapView, // Store the view object
    changeView: null as any,
    activemapView: "" as any,

    // scale
    ScaleBar: null as null | ScaleBar, 

    // roofs generated counts 
    roofCounts: 0,

    // markers and polyline with length symbol
    lineGraphic: null as any,

    lineGraphicList: [] as any[],
    textGraphic: null as any,
    textGraphicList: [] as any[],

    // polygon counts and titles count
    polygonListCounts: [] as any[],
    polygonTitles: [] as string[],
    tempgraphic: null as Graphic | null,

    // 
    isBuildingThere: false,
    // panel generation variables for rooftop simulation
    mainPoly: null as any,
    geomPoly: [] as any[],
    elevationP: 0 as number,
    altitude: 0 as number,
    latitude: 0 as number,
    longitude: 0 as number,
    height: 0 as number,
    currentSelectedGraphic: 0 as number,
    // azimuth: 15 as number,  // incline angle for building
    azimuth: 0 as number,  // incline angle for building
    tilt: 0 as number,  // tilt angle for panels

    // state to store total number of roof top oanels layed out on roofs as layers 
    roofTitlename: "RoofTop Module",
    roofTopModuleCount: [] as any[],

    // draw and edit tools 
    activeView: "2D" as "2D" | '3D', // current active view type
    lastactiveTool: "" as "circle" | 'polygon' | "rectangle", // current active draw tool

    snapOptions: {
        snapEnabled: true,
        snapToVertex: true,
        snapToEdge: true,
        tolerance: 15 // Adjust the tolerance distance as needed (in pixels)
    }, // draw snap tools

    sketchButton: {
        polygon: null as null | HTMLElement,
        circle: null as null | HTMLElement,
        rectangle: null as null | HTMLElement,
        polyline: null as null | HTMLElement,
        delete: null as null | HTMLElement,
        select: null as null | HTMLElement,
        refresh: null as null | HTMLElement,
        measurement: null as null | HTMLElement,
        zoomIn: null as null | HTMLElement,
        zoomOut: null as null | HTMLElement,
        featureAdd: null as null | HTMLElement,
        currentButtonClicked: null as null | "left" | "right",

        keyCode : '' as 'Escape' | ''
    }, // draw or edit buttons 

    // table mudule feature add or remove state
    featureAddState: null as null | 'active' | "delete" | 'select',
    isSelected: false as boolean,

    // solar module symbol and boundry geometry
    polygonGeomforLayout: null as any,
    panles_2d: null as any,
    panles_3d: null as any,

    // circle type polygon 
    circleLineGraphic: null as any, // for inittial polyline or top to center polyline
    circleTextGraphicTop: null as any,
    leftLineCirclePolyGraphic: null as any,
    leftLineCirclePolyGraphicSymbol: null as any,
    circleTextGraphic: null as any,

    /// editor for skethc 
    editor: null as null | __esri.Editor,


   // sketch and graphic layer tools 
//    indiLayers: null as null | __esri.GraphicsLayer, // Store the sketch graphics layer for table blocks
   prevsketchLayers: null as null | __esri.Graphic, // Store the sketch graphics layer
   sketchLayers: null as null | __esri.GraphicsLayer, // Store the sketch graphics layer
   graphic3dLayers: null as null | __esri.GraphicsLayer, // Store the sketch graphics layer
   measurement: null as null | __esri.Measurement,
   container: null as null | HTMLDivElement,
   searchWidgetInput: null as any,
   projectSearch: null as any,
   LocationMarkerPointGraphic: null as null | __esri.Graphic,
   graphicLayerLocation: null as null | __esri.GraphicsLayer,

   roofGroupLayer: null as null | __esri.GroupLayer,
   totaltableCount:null as null|number,

    // to hold all the roof modules that are generated
    roofModuleGraphicLayer: null as null | __esri.GraphicsLayer,

    shadowCastWidget: null as __esri.ShadowCast | null,
    groupLayer: null as __esri.GroupLayer | null,
    // sketchview Modal
    sketchViewModel: null as any,
    // ViewModal for Sketch
    sketchVM: {} as __esri.Sketch,
    sketchHandleWatcher: {} as IHandle,
    selectedGraphic: null as __esri.Graphic | null,
    multipleSelectedGraphic: [] as __esri.Graphic[],

    // additional properties here
    selectedRoof: {
        properties: {} as LayerProperties,
        objectid: '' as string
    },

    // footer lat & lng
    footers: {
        lat: null as null | HTMLElement,
        lng: null as null | HTMLElement,
    },

    // feature layer/WFS layers 
    featureLayers: {
        buildingFeatureDhaka: null as __esri.FeatureLayer | null,
        layerlist: null as __esri.LayerList | null,
        wfsLayers: [] as __esri.WFSLayer[],
        groupLayer: {} as __esri.GroupLayer
    },
     wmsLayers: {
        baselayer: 'pvbuilding:basebuilding',
        buildingname: 'pvbuilding:buildings',
        buildingname_old: 'pvbuilding:Building',
        type: 'geometry',
        type_old: 'the_geom',
        
        
        layerNames_old: [
            "pvbuilding:Water_Tanks",
            "pvbuilding:Existing_Solar_Modules",
            "pvbuilding:HVAC_Equipment",
            "pvbuilding:Mumty_Structure",
            "pvbuilding:Parapet_Wall",
            "pvbuilding:Pipelines",
            // "pvbuilding:Roof_Ridge",
            "pvbuilding:Extended_Columns",
            "pvbuilding:Chimneys",
            "pvbuilding:Skylights",
            "pvbuilding:Tree_Line",
            "pvbuilding:Turbovents" // on metal also
        ],
        layerNames_new: [
            // "pvbuilding:RCC_Roof",
            "pvbuilding:water_tanks",
            "pvbuilding:existing_solar_modules",
            "pvbuilding:hvac_equipment",
            "pvbuilding:mumty_structure",
            "pvbuilding:parapet_wall",
            "pvbuilding:pipelines",
            "pvbuilding:extended_columns",
            "pvbuilding:chimneys",
            "pvbuilding:skylights",
            "pvbuilding:tree_line",
            "pvbuilding:turbovents" // on metal also

        ],
        roofLayers_old: [
            'pvbuilding:RCC_Roof',
            // 'pvbuilding:Metal_Roof',
            // 'pvbuilding:Roof_Ridge'
        ],
        roofLayers: [
            'pvbuilding:roof',
            // 'pvbuilding:Metal_Roof',
            // 'pvbuilding:Roof_Ridge'
        ],

        metalRoofObs: 'pvbuilding:Roof_ridge',
        buildingLayer: 'pvbuilding:Building',

        baseLayer: null as GraphicsLayer | null,
        baseBuildingLayer: {} as Graphic,

        wms_roof_height: 0

    },
    goto: function (latitude: number, longitude: number) {
        try {
            if (!this.view) return;
            if(this.view.zoom < 19){
                this.view?.goTo({
                    center: [longitude, latitude],
                    zoom: 20
                }, {
                    animate: true
                })
            }

        }
        catch (e) {
        }
    },
    addWMSLayerBuilding: async function (polygon?: Polygon) {
        if (!this.map) return;

        if (this.wmsLayers.baseLayer) {
            this.map?.layers.remove(this.wmsLayers.baseLayer)
        }

        // height
        const height = this.selectedRoof.properties.height ?
            typeof this.selectedRoof.properties.height === 'string' ? parseInt(this.selectedRoof.properties.height) : 0
            : 0;
        // first create graphic for basebuilidng 
        // this.wmsLayers.baseBuildingLayer = new Graphic({
        //     geometry: polygon,
        //     symbol: buildingSymbologyHeight(height)
        // })

        this.wmsLayers.baseLayer = new GraphicsLayer({
            title: 'wmslayers'
        });

        // this.wmsLayers.baseLayer.graphics.add(this.wmsLayers.baseBuildingLayer);

        this.map?.layers.add(this.wmsLayers.baseLayer);

    },
    convertCoordinateSystem: async function (geometry: Polygon | Polyline, outputwkid: 102100 | 4326) {
        try {
            if (geometry.spatialReference.wkid === outputwkid) {
                return geometry;
            } else {
                const outSpatialReference = new SpatialReference({ wkid: 102100 });
                const convertedGeometry = projection.project(geometry, outSpatialReference);
                return convertedGeometry as Polygon;
            }
        } catch (error) {
            // Handle any errors that might occur during module loading or projection
            console.error("Error converting spatial system:", error);
            return null;
        }
    },
    zoomToGeometry: function async (geometry: __esri.Geometry, zoom = 18) {
        try {
            if(typeof(geometry) !== "object"){
                throw new Error("Invalid Geometry");
            }
            if(geometry.type === 'point'){
                globalLayers.view!?.goTo({
                    center: [(geometry as Point).longitude, (geometry as Point).latitude],
                    zoom: zoom
                })
                return;
            }
            if (!geometry || !(geometry as any).centroid) {
                console.error("Invalid geometry or missing centroid property.");
                return;
            }

            const centroid = (geometry as any).centroid;
            if (!centroid.longitude || !centroid.latitude) {
                console.error("Centroid does not have valid longitude and latitude.");
                return;
            }

            globalLayers.view!?.goTo({
                center: [centroid.longitude, centroid.latitude],
                zoom: 18
            })
        }
        catch (e: any) {
            console.error('Error during goTo operation:', e);
            toast.error(e.message,{autoClose: 7000})
        };
    },

    /// all the methods & operation start down here 
    // to switch current view type 
    toggleMapView: async (project?: ProjectTy | null) => {
        return await switchView(globalLayers.activeView, project);
    },

    addSketchDraw: async () => {
        await addsketchView()
    },

    // skecth handle here 
    sketchWatcherHandle: function() {
        // Reactive utility for watching the active tool
        this.sketchHandleWatcher = reactiveUtils.watch(
            () => this.sketchVM.activeTool, // Directly return the active tool
            (activetool: any) => {
                console.log("Active Tool:", activetool); // Log or handle active tool changes

                
            }
        );
    },

    skecthVMRefresh: async function (Sketch: any, skecthObject: any) {

        if (Object.keys(this.sketchVM).length > 0) {
            this.sketchVM.destroy()
            this.sketchVM = {} as __esri.Sketch;
        }
        if (Object.keys(this.sketchVM).length === 0) {
            this.sketchVM = new Sketch(skecthObject)
            // Wrap sketchHandle to comply with IHandle

             // Wrap the sketchHandle to comply with __esri.IHandle
            const sketchHandleWrapper: __esri.Handle = {
                remove: () => {
                    if (this.sketchHandleWatcher) {
                        this.sketchHandleWatcher.remove(); // Remove watcher when needed
                        console.log("Sketch handle watcher removed.");
                    }
                },
            };
            // Call sketchHandle to initialize the watcher
            this.sketchWatcherHandle();

            this.sketchVM.addHandles(sketchHandleWrapper);
        }

    },

     // Function to stop drawing or updating on Sketch widget
    stopSketch:async function () {
        if (this.sketchVM) {
          // Cancel any active drawing or updating process
          this.sketchVM.cancel();
        }
      },
    

    // to remove all the found title in the sketch layers by the provided title
    removeTitledGraphicsfromSkecth: function (title: string[]) {
        let deleteGraphics = [] as __esri.Graphic[]
        this.sketchLayers?.graphics.forEach((ele: any) => {
            if (title.includes(ele.title)) {
                deleteGraphics.push(ele)
            }
        });

        if (title.length) {
            title.forEach(name => {
                if (this.lineGraphic?.title === name) {
                    this.lineGraphic = null
                }
            })
        }
        this.sketchLayers?.graphics.removeMany(deleteGraphics);
        deleteGraphics = []
    },

    spatialReference: async function (): Promise<__esri.SpatialReference> {
        const [SpatialReference] = await loadMultipleModules(["esri/geometry/SpatialReference"])
        return new SpatialReference({
            wkid: 4326
        })
    },
    // to create Graphic
    createGraphic: function (geometry: any, symbol: any, title: any, visible?: boolean): Graphic {
        return new Graphic({
            geometry,
            symbol,
            visible,
            attributes: {
                title,
                name: title
            }
        })
    },

    // to create Polyline from given paths 
    createPolylineGeometry: async function (paths: number[][][], title: string) {
        const [Polyline] = await loadMultipleModules(["esri/geometry/Polyline"])
        // Create a Polyline object using the paths
        const polyline = new Polyline({
            paths: paths,
            spatialReference: { wkid: 4326 } // Use the appropriate spatial reference
        });
        // const graphic = await globalLayers.createGraphic(polyline, PvSymbols.simpleFillSymbol([255,0,0], [0.5,0.5,0.5]), title)
        return polyline;
    },

    // remove selected  skect graphic
    deleteSelectedGraphics: function () {
        const selectedGraphics = this.sketchVM.updateGraphics;
        if (selectedGraphics.length > 0) {
            // Loop through the selected graphics and remove them from the GraphicsLayer
            selectedGraphics.forEach(selectedGraphic => {
                this.sketchLayers?.graphics.remove(selectedGraphic);
            });

            // Clear the selection after deleting
            this.sketchVM.cancel();
        } else {
            console.error("No feature selected. Please select a feature first.");
        }
    },

    setBaselayer: async function (baseMap: string) {
        let newBasemap;

    if (this.activeBasemap === baseMap) return true;

    if (baseMap === 'apple') {
        if (!this.map || !this.mapView2d) return false;
        // Throws when MapKit can't be used here; the caller reports it.
        await showAppleBasemap(this.mapView2d);
        // An empty basemap lets the MapKit map behind the view show through.
        const { CdnBasemap } = await loadBasemapClasses();
        this.map.basemap = new CdnBasemap({ baseLayers: [], title: "Apple Maps", id: "apple-basemap" });
        (this.mapView2d as any).background = { color: [0, 0, 0, 0] };
        this.activeBasemap = baseMap;
        return true;
    }

    try {
        if (baseMap.toLowerCase() === 'google') {
            newBasemap = await createGoogleBasemap();
            this.googleBasemap = newBasemap;
        } else {
            newBasemap = (await loadBasemapClasses()).CdnBasemap.fromId(baseMap);
        }

        if (!newBasemap) {
            console.warn(`Basemap with ID '${baseMap}' not found.`);
            return;
        }

        await newBasemap.loadAll();

        const baseLayer = newBasemap.baseLayers.getItemAt(0) as any;
        if (baseLayer && baseLayer.loadStatus !== "loaded") {
            await baseLayer.load();
        }

        // Assign spatial reference if still missing
        if (!(baseLayer as any).spatialReference) {
            (baseLayer as any).spatialReference = new SpatialReference({ wkid: 102100 });
        }

        // Ensure compatibility
        if (baseLayer.spatialReference?.wkid !== this.view?.spatialReference?.wkid) {
            console.warn('Basemap and view spatialReference mismatch. Zoom level may behave unexpectedly.');
        }

        if(!this.map) return false
        hideAppleBasemap();
        if (this.mapView2d) (this.mapView2d as any).background = null;
        // 🔥 Just replace the whole basemap — no need to mutate old layers
        this.map.basemap = newBasemap;
        this.activeBasemap = baseMap;

        // 💥 Remove residual custom layers (especially from Google)
        this.map.layers.forEach((layer) => {
            if (layer.title?.toLowerCase().includes("google")) {
                this.map?.layers.remove(layer);
            }
        });

        console.info(`Basemap changed to '${baseMap}'`);
        return true;

    } catch (error) {
        console.error(`Error setting basemap '${baseMap}':`, error);
        return false;
    }

    },
    setBinglayer: function (bmap:string) {
        //const { GraphicsLayer, Map, MapView,BingMapsLayer } = await lazyLoadArcGisMapModules();
        loadModules(['esri/layers/BingMapsLayer', "esri/views/MapView", "esri/Map"])
            .then(([BingMapsLayer, MapView, Map]) => {
                let bingmap1
                if(bmap==="esri"){
                    bingmap1 = new Map({                    
                           basemap: "satellite",
                           ground: "world-elevation",
                           layers: [globalLayers.graphicLayerLocation],
                        
                       
                   });
                  

                }else if(bmap==="bing"){
                     bingmap1 = new Map({
                        basemap: {
                            baseLayers: [new BingMapsLayer({
                                style: "aerial", // Specify the Bing Maps style (options: "aerial", "road", "hybrid", "canvasDark", "canvasLight", "birdseye", "birdseyeAerial")
                                key: "AkTWG50yjCD1xIYtd_-gBFbrLdthMQwWHCN-KYZx89ecBiNwR-A1ZwCrnqxGrwmB"
                            })]
                        }
                    });
                    

                }

                // this.map = new Map({
                //     basemap: "satellite",
                //     ground: "world-elevation",
                //     layers: [globalLayers.graphicLayerLocation],
                // });

                globalLayers.view = new MapView(
                    {
                        container: globalLayers.container,
                        map: bingmap1,
                        center: globalLayers.userCurrentLocation?[globalLayers.userCurrentLocation.lng, globalLayers.userCurrentLocation.lat]:[72.85669,19.08489],
                        zoom: globalLayers.currentZoomLevel
                    });
            })
            .catch(e => console.log(e))
    },

    // Method to add a graphic to the map
    addGraphic: function (graphic: __esri.Graphic, title: string) {
        if (this.view && this.view.map) {
            const graphicsLayer = new __esri.GraphicsLayer({
                title: title
            });
            graphicsLayer.add(graphic);
            this.view.map.add(graphicsLayer);
        } else {
            console.warn("Couldn't find the view/map")
        }
    },

    // Method to find a graphic by its title
    GetGraphicLayerbyTitle: function (title: string): __esri.Layer | null {
        let graphicsLayer: __esri.Layer | null = null;
        if (this.view && this.view.map) {
            this.view.map.allLayers.forEach(ele => {
                if (ele.title === title) {
                    graphicsLayer = ele
                }
            })
        }
        return graphicsLayer;
    },
    getGraphicbyName: function (name: string): Graphic | null {
        let selectedGraphic: Graphic | null = null;
        if (this.sketchLayers && this.sketchLayers.graphics.length) {
            this.sketchLayers.graphics.forEach(ele => {
                if(ele.geometry && ele.geometry.type === 'polygon'){
                    selectedGraphic = ele
                }
            })
        }
        return selectedGraphic;
    },

    RemoveLayer: function (title: string): boolean {
        let graphicsLayer: __esri.Layer | null = null;
        if (this.view && this.view.map) {
            this.view.map.allLayers.forEach(ele => {
                if (ele.title === title) {
                    graphicsLayer = ele
                    this.view?.map.remove(ele);
                    console.log(`${title} removed successfully`)
                }
            })
        }
        if (graphicsLayer) {
            console.warn(`${title} removed successfully`)
            return true
        }
        console.error(`${title}: could not find this layer`)
        return false
    },

    Removeaddress: function () {
        if (this.searchWidgetInput) {
            this.searchWidgetInput.clear()
        }
    },

    addNewFeatureLayer: function (title: string, layer: any) {
        if (this.map) {
            const layers = this.map?.layers as any
            let featureLyar = layers._items.filter((ele: any) => ele.title === title)
            if (!featureLyar.lenght) {
                this.map.add(layer)
            }
        }
    },

    addGroupLayer: function (title: string) {

        loadModules(["esri/layers/GroupLayer"])
            .then(([GroupLayer]) => {
                this.groupLayer = new GroupLayer({
                    title: title
                });
                this.map?.add(globalLayers.groupLayer!);
            })
            .catch(e => console.error(e))
    },

    toggleLocationPin: function () {
        if (this.map) {
            (this.map.allLayers as any).items.forEach((ele: any) => {
                if (ele?.title === "locationMarker") {
                    if (ele.visible) {
                        ele.visible = false
                    } else {
                        ele.visible = true
                    }
                } else {
                    console.error("No Location Graphic Found")
                }
            })
        } else {
            console.error("No view attached to map")
        }
    },

    addHeighttoGraphic: async function (height: number, tilt: number, azimuth: number) {

        const [GraphicsLayer, Point] = await loadMultipleModules(["esri/layers/GraphicsLayer", "esri/geometry/Point"])
        if (this.sketchVM.updateGraphics === undefined) {
            console.warn('No layer selected')
            return;
        }
        const currSelectGraphicList = (this.sketchVM.updateGraphics as any)._items as __esri.Graphic[]
        if (currSelectGraphicList.length === 0) return

        currSelectGraphicList.forEach((currGraphic: any) => {
            currGraphic.attributes = { ...currGraphic.attributes, height: height }
            const attributes = currGraphic.attributes;
            let geometry = currGraphic.geometry as any

            if (geometry.type !== "polygon") return;
            const centerCoordinates = (geometry as any).centroid;
            // const adjocentHeight = height * Math.tan(90 - tilt);
            geometry.hasZ = true
            const pointGeometry = new Point({
                latitude: centerCoordinates.latitude,
                longitude: centerCoordinates.longitude,
                z: globalLayers.altitude,
            });

            const graphicLayer = new GraphicsLayer({
                title: "3d",
                id: '3d'
            });

            convertGeometryToWebMercator(pointGeometry)
                .then(updatedGeometry => {
                    let centerLong = updatedGeometry?.x; // longitude for point geometry in spatialreference wkid 102100
                    let centerLat = updatedGeometry?.y; // latitude for point geometry in spatialreference wkid 102100
                    // adding height to all the rings in the geometry
                    if (geometry.rings.length > 1) {
                        for (let i = 0; i < geometry.rings.length; i++) {
                            for (let j = 0; j < geometry.rings[i].length; j++) {
                                let long = geometry.rings[i][j][0];
                                let lat = geometry.rings[i][j][1];
                                let heig = pointGeometry?.z;
                                if (centerLong > long) {
                                    geometry.rings[i][j][2] = heig;
                                    // return 'right';
                                } else if (centerLat < lat) {
                                    geometry.rings[i][j][2] = heig;
                                    // return 'left';
                                } else {
                                    geometry.rings[i][j][2] = heig;
                                    // return 'same';
                                }
                            }
                        }

                        const graphic = this.createGraphic(geometry, extrudeSymbol3D(40, "red"), '', false)
                        graphicLayer.add(graphic);
                        globalLayers.view?.map.add(graphicLayer);
                            
                    }
                    else {
                        const ring: number[][] = geometry.rings[0]
                        const updatedGeometry = this.updateGeomrtyRingswithTilt(currGraphic, ring, pointGeometry, centerLong, geometry, centerLat)
                        const color = getRandomColorArray()
                        const graphic = this.createGraphic(updatedGeometry, extrudeSymbol3D(height, color), currGraphic?.title ?? 'graphic-building' , false)
                        if (globalLayers.graphic3dLayers) {
                            globalLayers.graphic3dLayers.graphics.forEach((layer: any) => {
                                // look for the existing same graphic layer and update it with the new graphic here
                                if (layer.title === geometry?.title) {
                                    globalLayers.graphic3dLayers?.graphics.remove(layer);
                                }
                            })
                            graphic.attributes = attributes;
                            if (graphic.attributes && graphic.attributes.radius) {
                            }
                            globalLayers.graphic3dLayers?.add(graphic)
                        }
                            
                    }
                })
                .catch(e => console.error(e))

        })
        return globalLayers.graphic3dLayers;
    },

    changeAzimuth: async function () {

        if (!this.lastDrawnRoofBoundryGraphicTitle) return;
        let title = this.roofTitlename + this.roofTopModuleCount.length;
        // remove previously drawn rooftop graphics 

        // this.map?.remove(this.indiLayers!);
        // let boundry = this.lastDrawnRoofBoundryGraphicTitle;
        await pvHandleRoofTop(this.lastDrawnRoofBoundry, this.elevationP, title)
    },

    show3dView: async function (project?: ProjectTy | null) {
        const mapView = this.mapView2d;
        const container = document.getElementById(SCENE_3D_CONTAINER_ID) as HTMLDivElement | null;
        if (!mapView || !this.map || !container) return false;
        this.disposeSceneView();
        // The 2D MapView stays as it is (sketching, search and markers keep
        // working on it); the 3D preview is a separate SceneView drawn over
        // it with its own map and 3D symbols of the saved design.
        const [CdnMap, CdnSceneView] = await loadMultipleModules(["esri/Map", "esri/views/SceneView"]);
        const { CdnBasemap } = await loadBasemapClasses();
        const basemap = this.activeBasemap === "apple" || this.activeBasemap === "google"
            ? await createGoogleBasemap().catch(() => CdnBasemap.fromId("satellite"))
            : CdnBasemap.fromId(this.activeBasemap) ?? CdnBasemap.fromId("satellite");
        const sceneLayers = await buildProjectScene3dLayers(project ?? this.currentSelectedProject?.[0] ?? null);
        const scenemap: Map = new CdnMap({ basemap, ground: "world-elevation", layers: sceneLayers });
        this.scenemap = scenemap;
        // One ground height for the whole design, sampled at the roof, so the
        // building and everything on it share the same base.
        try {
            const roofGraphic = sceneLayers.find((layer) => layer.id?.startsWith("consumer-project-3d-roof-"))?.graphics.getItemAt(0);
            const anchor = (roofGraphic?.geometry as any)?.centroid ?? roofGraphic?.geometry?.extent?.center ?? mapView.center;
            await scenemap.ground.load();
            const sample = await scenemap.ground.queryElevation(anchor);
            anchorScene3dLayers(sceneLayers, Number((sample.geometry as any)?.z) || 0);
        } catch (error) {
            console.warn("Could not sample the ground height for the 3D roof; using sea level.", error);
        }
        container.style.display = "block";
        try {
            const sceneView: SceneView = new CdnSceneView({
                map: this.scenemap,
                container,
                center: mapView.center?.clone(),
                zoom: mapView.zoom,
                // No on-map controls: the toolbar's compass follows this view
                // instead, and zoom/pan/rotate are done with the mouse.
                ui: { components: [] },
                qualityProfile: "high",
                environment: { lighting: { directShadowsEnabled: true } as any },
            });
            this.sceneView = sceneView;
            if (this.compassWidget) this.compassWidget.view = sceneView;
            // The compass widget comes from @arcgis/core and can't observe this
            // CDN-built view, so turn the compass box with the camera heading
            // (the 2D map's rotation watcher in MapArea does the same).
            const [cdnReactiveUtils] = await loadMultipleModules(["esri/core/reactiveUtils"]);
            this.sceneHeadingWatch?.remove();
            this.sceneHeadingWatch = cdnReactiveUtils.watch(
                () => sceneView.camera?.heading,
                (heading: number | undefined) => {
                    const box = document.getElementById("compass-widget");
                    if (box) box.style.transform = `rotate(${-(heading ?? 0)}deg)`;
                },
                { initial: true }
            );
            await sceneView.when();
            // Keep the roof in focus, without animating (so the map doesn't
            // appear to fly somewhere else): frame the roofs when the 2D map
            // shows them whole, or keep the exact 2D spot and scale when the
            // user has zoomed into part of a roof.
            const roofs = sceneView.map.layers
                .filter((layer) => layer.id?.startsWith("consumer-project-3d-roof-"))
                .toArray()
                .flatMap((layer) => (layer as GraphicsLayer).graphics.toArray());
            const heading = mapView.rotation ? 360 - mapView.rotation : 0;
            const zoomedIntoRoof = roofs.some((roof) =>
                roof.geometry?.extent?.contains(mapView.center) && !mapView.extent?.contains(roof.geometry.extent));
            const viewpoint = zoomedIntoRoof || !roofs.length
                ? { center: mapView.center, scale: mapView.scale, tilt: 60, heading }
                : { target: roofs, tilt: 60, heading };
            await sceneView.goTo(viewpoint, { animate: false }).catch(() => undefined);
            return true;
        } catch (error) {
            this.disposeSceneView();
            throw error;
        }
    },

    disposeSceneView: function () {
        this.sceneHeadingWatch?.remove();
        this.sceneHeadingWatch = null;
        if (this.compassWidget && this.mapView2d && this.compassWidget.view !== this.mapView2d) {
            this.compassWidget.view = this.mapView2d;
            const box = document.getElementById("compass-widget");
            if (box) box.style.transform = `rotate(${-(this.mapView2d.rotation ?? 0)}deg)`;
        }
        this.sceneView?.destroy();
        this.sceneView = null;
        this.scenemap?.destroy();
        this.scenemap = null;
        const container = document.getElementById(SCENE_3D_CONTAINER_ID);
        if (container) container.style.display = "none";
    },

    show2dView: function (_MapView?: any) {
        this.disposeSceneView();
        this.view = this.mapView2d ?? this.view;
        // globalLayers.sketchVM.complete()
        // if (this.activeView === "3D") {
        //     return "MapView is already in 2D Mode."
        // }
        // const center = this.sceneView?.center.clone()!;

        // if(!this.sketchLayers){
        //     this.sketchLayers = new GraphicsLayer({
        //         title: "sketch-layer",
        //         id: "sketch-layer",
        //     });
        // }

        // if(this.shadowCastWidget){
        //     this.shadowCastWidget.destroy()
        // }

    

        // const map = new Map({
        //     basemap: "hybrid",
        //     ground: "world-elevation",
        //     layers: [this.graphicLayerLocation!],
        // });

        // this.view = new MapView({
        //     container: globalLayers.container!,
        //     map: map,
        //     center,
        //     zoom: this.sceneView?.zoom,
        //     ui: {
        //         components: []
        //     },
        // });

    
        // globalLayers.addSketchDraw().then(() => {
        //     console.log('sketch-added')
        // })

        // globalLayers.view?.when(() => {
        //     // if(globalLayers.activeView === '3D') return;
        //     let compass = new Compass({
        //       view: globalLayers.view!,
        //     });
        //     if(document.getElementById('compass-widget')){
        //       compass.container = document.getElementById('compass-widget') as HTMLElement
        //     }
        //     // if(globalLayers.indiLayers){
        //     //   globalLayers.indiLayers.visible = false
        //     // }
        //     if(globalLayers.view){
        //       globalLayers.ScaleBar = new ScaleBar({
        //         view: globalLayers.view as any,
        //         unit: "dual" // The scale bar displays both metric and imperial units.
        //       });
        
        //       // Add the widget to the bottom left corner of the view
        //       globalLayers.view.ui.add(globalLayers.ScaleBar, {
        //         position: 'bottom-left'
        //       });
        //     }
    
        //   })


          setTimeout(() => {
            // if(this.sketchLayers?.graphics.length){
            //     this.sketchLayers?.graphics.forEach(graphic => {
            //         if(graphic.geometry.type === 'polygon'){
            //             try {
            //                 this.view?.goTo({
            //                     target: graphic.geometry.extent,
            //                 });
                            
            //             } catch (error) {
                            
            //             }
            //         }
            //     })
            //     // add it to map layer of skecth object 
                
            //   }
          }, 1500);
    },

    switchGraphicsView: function (type: "sketch-layer" | '3d') {
        if (type === "3d") {
            // this.show3dView()
        } else {
            // this.show2dView()
        }
    },

    // create the duplicate graphics
    createDuplicate: function () {
        const toastId = 'copypolygon'
        let titles = [] as string[]
        this.sketchVM.updateGraphics.forEach((ele: any) => {
            if (titles.includes(ele.title)) return
            titles.push(ele.title)
        })

        if (this.sketchVM.updateGraphics.length > 0) {
            this.sketchLayers?.graphics.forEach(layer => {
                if (titles.includes((layer as any).title)) {
                    let clonedGraphic = layer.clone();
                    (clonedGraphic as any).title = (layer as any).title as string + "-" + "copy";
                    this.sketchLayers?.graphics.add(clonedGraphic)
                }
            })
            toast.success('Graphic Copied Successfully.', { toastId, autoClose: 7000 });

        } else {
            toast.warn('No graphic selected. Please select a graphic first.', { toastId, autoClose: 7000 })
        }
    },

    createDuplicateGraphic: function (title: string, filterLayerByName: __esri.Graphic[]) {
        const toastId = 'copy-polygon'
        // check if the props titlename graphic already exists 
        let alredayExistGraphic = this.sketchLayers?.graphics.filter((layer: any) => layer.title === title)
        if (alredayExistGraphic && alredayExistGraphic.length > 0) return; // graphic alredy exists now either return from here or remove them then attach again 
        let newCopiedGraphics = [] as __esri.Graphic[]
        for (let i = 0; i < filterLayerByName.length; i++) {
            let originalGraphic = filterLayerByName[i];
            let copiedGraphic: any = originalGraphic.clone(); // Create a shallow copy
            copiedGraphic.title = title;
            newCopiedGraphics.push(copiedGraphic);
        }
        this.sketchLayers?.graphics.addMany(newCopiedGraphics);
        newCopiedGraphics.forEach((ele: any) => {
            if (!this.polygonListCounts.includes(ele.title)) {
                this.polygonListCounts.push(ele.title)
            }

        })
        toast.success('Graphic Copied Successfully.', { toastId, autoClose: 7000 });
    },

    // Flip the selected geometry / Graphic
    fliptheGeom: async function () {
        const [geometryEngineAsync, Graphic] = await loadMultipleModules(["esri/geometry/geometryEngineAsync", "esri/Graphic"])
        const selectedGraphicLayer = globalLayers.selectedGraphic


        if (selectedGraphicLayer === null) {
            console.warn("No selected layer found.")
            return
        }

        const flipGeom = await geometryEngineAsync.flipHorizontal(selectedGraphicLayer.geometry);

        const flippedGeometryRotate = await geometryEngineAsync.rotate(flipGeom, 12)

        const flippedGraphic = new Graphic({
            geometry: flippedGeometryRotate,
            symbol: selectedGraphicLayer.symbol,
            title: 'flip'
        });

        this.sketchLayers?.remove(selectedGraphicLayer);
        this.sketchLayers?.add(flippedGraphic)
        this.selectedGraphic = flippedGraphic

        return flippedGraphic



    },

    shadowCast: async function (toggle: "add" | "remove") {
        if (toggle === "add") {
            const [ShadowCast] = await loadMultipleModules(["esri/widgets/ShadowCast"])
            globalLayers.shadowCastWidget = new ShadowCast({
                view: this.view,
                container: "shadowCast",
                title: "shadowcast",
                visibleElements: { tooltip: true }
            })
        } else {

            if (globalLayers.shadowCastWidget) {
                globalLayers.shadowCastWidget.visible = false;
                globalLayers.shadowCastWidget.visibleElements.tooltip = false;
            }
        }
    },

    add3DGraphicLayer: async function () {
        if (this.graphic3dLayers) {
            this.view?.map.add(this.graphic3dLayers)
        }
    },

    convertSpatialSystem: async function (geometry: any) {
        try {
            const [projection, SpatialReference] = await loadMultipleModules(["esri/geometry/projection", "esri/geometry/SpatialReference"]);
            await projection.load();

            if (geometry.spatialReference.wkid === "4326") {
                const res = this.removeZfromRings(geometry);
                return res;
            } else {
                const outSpatialReference = new SpatialReference({ wkid: 4326 });
                const convertedGeometry = projection.project(geometry, outSpatialReference);
                if(!convertedGeometry || !convertedGeometry?.rings) return null;
                const res = this.removeZfromRings(convertedGeometry);
                return res;
            }
        } catch (error) {
            // Handle any errors that might occur during module loading or projection
            console.error("Error converting spatial system:", error);
            return null;
        }
    },

    removeZfromRings: function (geometry: any) {
        const newRings = geometry.rings.map((ring: any) => {
            return ring.map((item: any) => [item[0], item[1]]);
        });
        geometry.rings = newRings;
        return geometry;

    },

    updateGeomrtyRingswithTilt: function (graphic: any, ring: number[][], pointGeometry: __esri.Point, centerLong: number, geometry: any, centerLat: number) {
        for (let i = 0; i < ring.length; i++) {
            let long = ring[i][0];
            let lat = ring[i][1];
            // let heig = pointGeometry?.z;
            if (graphic.attributes?.type === "circle" || graphic.title === "select-rectangle") {
                geometry.rings[0][i][2] = 0;
            } else {
                if (centerLong > long) {
                    geometry.rings[0][i][2] = 0;
                } else if (centerLat < lat) {
                    geometry.rings[0][i][2] = 0 - 10;
                    // return 'left';
                } else {
                    geometry.rings[0][i][2] = 0 - 10;
                    // return 'same';
                }
            }
        }
        return geometry;

    },

    removeButtonEvents: function () {
        Object.entries(this.sketchButton)
            .forEach(items => {
                if (items && items[1] !== null) {
                    if (items[1]) {

                    }
                    // (items[1] as HTMLButtonElement)?.removeEventListener('click', () => {
                    //     // console.log('button click event removed..')
                    // })
                }
            })
    },

    removePolyLineswithTitle: function (title: string | string[], type?: string) {
        let removeGraphics = [] as __esri.Graphic[]
        if (this.lastactiveTool === "circle") return
        this.sketchLayers?.graphics.forEach((graphic: any) => {
            if (typeof (title) === "string") {
                if (graphic.title?.trim() === title?.trim() && (graphic.geometry.type === "polyline" || graphic.geometry.type === "point")) {
                    removeGraphics.push(graphic)
                }
            } else {
                if (title.includes(graphic?.title?.trim()) && (graphic.geometry.type === "polyline" || graphic.geometry.type === "point")) {
                    removeGraphics.push(graphic)
                }
            }
        });


        this.sketchLayers?.graphics.forEach((graphic) => {
            if(graphic.geometry && graphic.geometry.type !== 'polygon'){
                removeGraphics.push(graphic)
            }
        })

        if (removeGraphics.length) {
            this.sketchLayers?.graphics.removeMany(removeGraphics)
        }
   

    },

    togglePolyline: function (title: string, toggle: boolean) {
        if (this.sketchVM.state === "ready") {
            this.sketchLayers?.graphics.forEach((ele: Graphic) => {
                if (ele.geometry.type !== 'polygon') {
                    ele.visible = toggle
                    ele.symbol.color =  new Color('#000')
                }
            })
        }
        this.sketchLayers?.graphics.forEach((ele: any) => {
            if (!ele) return;
            if (ele.title && ele.title === title && ele.geometry.type !== 'polygon') {
                ele.visible = toggle
            }
        })
        this.sketchLayers?.graphics.map(ele => {
            if(ele.geometry && ele.geometry.type !== 'polygon'){
                ele.visible = false
            }
        })
    },
    hidePolyLines: function () {
        if (this.sketchVM) {
            this.sketchLayers?.graphics.forEach((ele) => {
                if (ele.attributes && (ele.geometry.type === 'polyline' || ele.geometry.type === 'point') && Object.keys(ele.attributes).length) {
                    if(ele.attributes.name){
                        ele.visible = false
                    }
                }
            })
        }
        this.sketchLayers?.graphics.forEach((ele: any) => {
            this.sketchLayers?.graphics.forEach((ele) => {
                if (ele.attributes && (ele.geometry.type === 'polyline' || ele.geometry.type === 'point') && Object.keys(ele.attributes).length) {
                    if(ele.attributes.name){
                        ele.visible = false
                    }
                }
                if (ele.attributes && (ele.geometry.type === 'polyline' || ele.geometry.type === 'point') && Object.keys(ele.attributes).length) {
                    if(ele.attributes.name){
                        ele.visible = false
                    }
                }
            })
        })
    }
}

export default globalLayers;

// export const basemapNames = [
//     'satellite',
//     'hybrid',
//     'dark-gray',
//     'oceans',
//     'national-geographic',
//     'terrain',
//     'osm',
//     'streets-navigation-vector',
//     'streets-relief-vector',
//     'streets-night-vector',
//     'streets-vector',
//     'topo-vector',
//     'gray-vector'
// ];

// Same choices as rooftop3d_epc's basemap controller, plus Apple Maps.
export const basemapNames = [
    'satellite',
    'hybrid',
    'osm',
    'google',
    'apple'
] as const;

export const mapLayesNames = [
    'esri',
    'bing'
];
